import React from 'react';

function Search(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M6.97888 2.65067C2.82266 4.41747 0.884855 9.21956 2.65149 13.3754C4.41827 17.5316 9.22036 19.4694 13.3762 17.7027C14.1691 17.3656 14.8813 16.9181 15.5025 16.3856L20.933 21.817L21.0196 21.8893C21.2632 22.058 21.5999 22.034 21.8169 21.817C22.061 21.573 22.061 21.1772 21.817 20.9331L16.386 15.5014C18.3426 13.2164 18.96 9.93375 17.7035 6.97803C15.9367 2.82173 11.1354 0.884131 6.97888 2.65067ZM15.1133 15.04C17.023 13.1001 17.684 10.1272 16.5532 7.46705L16.4542 7.24487C14.8835 3.87758 10.914 2.33642 7.46785 3.80106C3.94696 5.29779 2.30533 9.36592 3.80186 12.8864C5.29858 16.4073 9.36672 18.0489 12.8872 16.5524C13.714 16.2009 14.4372 15.7076 15.0405 15.1128C15.0516 15.0998 15.0633 15.0871 15.0756 15.0747C15.0878 15.0625 15.1004 15.051 15.1133 15.04Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Search;
